var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('nuxt-link',{class:_vm.align,attrs:{"to":'/' +
    _vm.getParentType(_vm.data.attributes.type) +
    '/case/' +
    _vm.data.attributes.slug}},[_c('Animation',[_c('div',{staticClass:"arrow"}),_vm._v(" "),_c('div',{staticClass:"bottom"},[_c('h2',[_c('span',{domProps:{"innerHTML":_vm._s(
            _vm.getParentType(_vm.data.attributes.type) === 'pictures'
              ? _vm.data.attributes.title
              : _vm.data.attributes.headline
          )}}),_vm._v(" "),_c('Media',{attrs:{"data":_vm.data.attributes.image.data,"aspectRatio":"16:9","lazy":false}})],1),_vm._v(" "),_c('h3',[_vm._v("\n        "+_vm._s(_vm.getParentType(_vm.data.attributes.type) === 'pictures'
            ? _vm.data.attributes.headline
            : _vm.data.attributes.title)+"\n      ")])])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }